import { Box } from "@mui/material";
import SivooTVPlus from "../components/Home/SivooTVPlus/SivooTVPlus";

const Home = () => {
  return (
    <div>
      <Box sx={{ flexGrow: 1, px: { xs: 4, md: 6 }, py: { xs: 5, md: 10 } }}>
        <SivooTVPlus />
      </Box>
    </div>
  );
};

export default Home;
